import React from "react";

const LearnHero = ({ content, menuIcon, menuName }) => {
  return (
    <div id="learn-hero" className="mt-auto">
      <div className="container text-left text-md-center">
        <div className="d-flex align-items-center justify-content-start justify-content-md-center mb-3 mb-md-4">
          <img
            src={menuIcon.publicURL}
            alt=""
            loading="eager"
            width={40}
            height={40}
          />
          <span
            style={{
              fontFamily: "Graphik",
              fontSize: "1.75rem",
              fontWeight: 600,
              color: "#152B43",
              marginLeft: "10px",
            }}
          >
            {menuName}
          </span>
        </div>
        <h1 className="mb-4">{content.hsMainHeading}</h1>
        <div dangerouslySetInnerHTML={{ __html: content.hsMainText }} />
      </div>
    </div>
  );
};

export default LearnHero;
